/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#\\90days[_ngcontent-%COMP%]{left:100%}.btn[_ngcontent-%COMP%]{right:0;opacity:.35}.btn[_ngcontent-%COMP%]:hover{opacity:.7}"];
export { styles as styles };
